import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/settings";
const options = {role: ROLE.RESTAURANT};


export const updateTipStatus = async (values) => {
  return await axiosInstance(options).post(`${path}/update-tip-status`, values);
};


export const updateArrivalTimeStatus = async (values) => {
  return await axiosInstance(options).post(`${path}/update-time-setting`, values);
};

export const updateCurrencyValues = async (values) => {
  return await axiosInstance(options).post(`${path}/update-currency-values`, values);
};